import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["status", "items", "formData"];
import React, { useState, useMemo } from 'react';
import { View, Text } from 'react-native';
import { Button } from '../../Button/rn';
import { ModeType, WebForm } from '.';
import { WebFormOrder } from '../../WebformOrder/rn';
import SubmitSuccess from '../../Image/rn/SubmitSuccess';
import styles from './style';
import { ComponentType } from './WebFormItem';
import { useLocale } from '../../LocaleProvider/rn';
export var WebFormPreview = function WebFormPreview(props) {
  var _orderInfo$map;
  var status = props.status,
    items = props.items,
    formData = props.formData,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var showItems = useMemo(function () {
    return items.filter(function (item) {
      return item.hidden !== true && ![ComponentType.FileUpload, ComponentType.WebFormOrder].includes(item.component);
    });
  }, [items]);
  var orderInfo = useMemo(function () {
    return items.filter(function (item) {
      return item.hidden !== true && [ComponentType.WebFormOrder].includes(item.component);
    });
  }, [items]);
  var showPopup = function showPopup() {
    setActive(true);
  };
  return /*#__PURE__*/React.createElement(View, {
    style: styles.webformPreviewWrapper
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: styles.webformPreviewHeader
  }, status ? /*#__PURE__*/React.createElement(SubmitSuccess, {
    style: styles.webformPreviewIcon
  }) : null, /*#__PURE__*/React.createElement(Text, {
    style: styles.webformPreviewHeaderText
  }, trans('webform_submit_card_title'))), /*#__PURE__*/React.createElement(View, {
    style: styles.webformPreviewContent
  }, (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.length) > 0 ? orderInfo === null || orderInfo === void 0 ? void 0 : (_orderInfo$map = orderInfo.map) === null || _orderInfo$map === void 0 ? void 0 : _orderInfo$map.call(orderInfo, function (item, index) {
    return /*#__PURE__*/React.createElement(WebFormOrder, _extends({
      key: index,
      value: formData === null || formData === void 0 ? void 0 : formData[item.name]
    }, item, {
      mode: ModeType.View,
      orderStyle: {
        borderBottomWidth: 0,
        paddingHorizontal: 0
      }
    }));
  }) : null, showItems.map(function (item) {
    var _formData$item$name;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: styles.webformPreviewItem,
      key: item.name
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.webformPreviewLabel
    }, item.label, ": "), /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      ellipsizeMode: "tail",
      style: styles.webformPreviewValue
    }, [ComponentType.RequestEmail, ComponentType.InputWithRegion].includes(item.component) ? formData === null || formData === void 0 ? void 0 : (_formData$item$name = formData[item.name]) === null || _formData$item$name === void 0 ? void 0 : _formData$item$name[1] : formData === null || formData === void 0 ? void 0 : formData[item.name])));
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      paddingLeft: 12,
      paddingRight: 12
    }
  }, /*#__PURE__*/React.createElement(Button, {
    text: trans('key_answer_view_more_btn'),
    onClick: showPopup
  })), /*#__PURE__*/React.createElement(WebForm, _extends({}, restProps, {
    items: items,
    formData: formData,
    active: active,
    onClose: function onClose() {
      return setActive(false);
    },
    mode: ModeType.View
  })));
};